import React from "react";

const Arrows = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 14 6" fill="none" {...props}>
      <path d="M14 3L9 0.113249V5.88675L14 3ZM0 3.5H9.5V2.5H0V3.5Z" fill="currentColor" />
    </svg>
  );
};

export default Arrows;
